/**
 * Modsy animated heart loader/spinner.
 * Must be placed inside a container with 'position: relative'.
 * Pass in scale parameter to adjust loader size.
 */
import React from 'react';
import styled from 'styled-components/macro';

import { Flex } from 'modsy-ui-kit';
import { LoadingIndicator } from 'web-ui-kit/loading';

const LoadingContainer = styled(Flex)`
  position: absolute;
  left: 0;
  top: 0;

  height: 100%;
  transform: scale(${props => props.scale || 0.25});
  width: 100%;
`;

export default function ModsyHeartLoader ({ className, scale }) {
  return (
    <LoadingContainer className={className} scale={scale}>
      <LoadingIndicator isLoading pastDelay />
    </LoadingContainer>
  );
}
